export interface IChangePasswordRequest {

    NewPassword: string;
    CurrentPassword : string;

    ValidationMessage : string;

    IsValid();

}

export class ChangePasswordRequest implements IChangePasswordRequest {

    public NewPassword: string;
    public CurrentPassword: string;

    public ValidationMessage: string;
    
    public IsValid(): boolean {

        if (this.NewPassword == undefined || this.NewPassword.length < 6) {
            this.ValidationMessage = "The new password must be at least 6 characters.";
            return false;
        }
        else if (this.CurrentPassword == undefined || this.CurrentPassword == "") {
            this.ValidationMessage = "The current password is empty.";
            return false;
        }
        else {
            this.ValidationMessage = "";
            return true;
        }
    }

}
